import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

export function glbLoader(path) {
    const gltfLoader = new GLTFLoader();
    return new Promise((resolve, reject) => {
        gltfLoader.load(path, gltf => {
            resolve(gltf.scene.children[0]); //select mesh out of scene array by loader
        });
    });
}
